import EnhancedOwnerTable from 'component/ContactTab/OwnerTable';
import { useState, useEffect, useContext } from 'react';
import { getOwnerDetails } from 'api/apiService';
import React from 'react';
import { LoaderContext } from 'component/Loader/LoaderContextProvider';
import Loading from 'assets/images/loading.png';
import { Grid, Box, Typography } from '@mui/material';
const headCells = [
  {
    id: 'name',
    numeric: false,
    disablePadding: true,
    label: 'Name',
  },
  {
    id: 'role',
    numeric: true,
    disablePadding: false,
    label: 'Role',
  },
  {
    id: 'contact',
    numeric: true,
    disablePadding: false,
    label: 'Contact',
  },

  {
    id: 'tag',
    numeric: true,
    disablePadding: false,
    label: 'Tag',
  },

  {
    id: 'action',
    numeric: true,
    disablePadding: false,
    label: 'Action Required',
  },
];

const ContactOwnerTabItem = ({
  setSelectedRows,
  onDataLoad,
  selectedRows,
  searchText,
}) => {
  const [properties, setProperties] = useState([]);
  const { setIsLoadingPage } = useContext(LoaderContext);
  const [loader, setLoader] = useState(true);

  useEffect(() => {
    const apiFunction = async () => {
      var mounted = true;
      await getOwnerDetails()
        .then((resp) => {
          if (mounted) {
            setProperties(resp);
          }
        })
        .finally(() => setLoader(false));
      return () => (mounted = false);
    };
    apiFunction();
  }, []);

  useEffect(() => {
    const dataToPass = Array.isArray(properties?.data)
      ? properties.data
      : Array.isArray(properties?.userDetails)
      ? properties.userDetails
      : [];

    if (dataToPass.length > 0 && onDataLoad) {
      onDataLoad(dataToPass);
    }
  }, [properties, onDataLoad]);

  const contactList = Array.isArray(properties?.userDetails)
    ? properties.userDetails
    : Array.isArray(properties?.data)
    ? properties.data
    : [];

  const filteredUserDetails = contactList.filter((item) =>
    `${item?.user?.userName || ''} ${item?.user?.userSurName || ''}`
      .toLowerCase()
      .includes(searchText.toLowerCase())
  );

  const filteredProperties = {
    ...properties,
    userDetails: filteredUserDetails,
  };

  return (
    <>
      {loader ? (
        <Grid
          sx={{
            display: 'flex',
            justifyContent: 'center',
            height: '100%',
            alignItems: 'center',
            flexDirection: 'column',
          }}
        >
          <Box>
            <img
              alt="Logo"
              src={Loading}
              className="loaderImage"
              style={{ height: '100px', width: '100px' }}
            />
          </Box>
          <Typography sx={{ fontFamily: 'poppins' }}>Loading...</Typography>
        </Grid>
      ) : searchText.trim() !== '' && filteredUserDetails.length === 0 ? (
        <Typography
          sx={{
            display: 'flex',
            justifyContent: 'center',
            fontSize: '14px',
            fontFamily: 'Poppins',
            padding: '20px',
          }}
        >
          No Search contact available
        </Typography>
      ) : (
        <>
          {properties?.status == 1 ? (
            <EnhancedOwnerTable
              headCells={headCells}
              properties={filteredProperties}
              setProperties={setProperties}
              setSelectedRows={setSelectedRows}
              selectedRows={selectedRows}
            />
          ) : (
            <Typography
              sx={{
                display: 'flex',
                justifyContent: 'center',
                fontSize: '14px',
                fontFamily: 'poppins',
                padding: '20px',
              }}
            >
              Owner not available
            </Typography>
          )}
        </>
      )}
    </>
  );
};
export default ContactOwnerTabItem;
